import React from "react";
import { InputJson } from "nq-component";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import OtherDeductionFormPresenter from "./OtherDeductionFormPresenter";
import FormFactory from "../../../../components/FormFactory";

class OtherDeductionFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      advanced: false,
      objectID: "",
    };
    this.presenter = new OtherDeductionFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "other_deductions";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
  }

  render() {
    const { object } = this.state;

    console.log("OBJECT", object);

    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>no schema</h1>;

    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.presenter.submit();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson defaultValue={object} rows="15" />
                    ) : (
                      <>
                        <FormFactory
                          className="col-md-12 "
                          uppercase
                          schema={schema}
                          object={object}
                          onChange={this.onChange.bind(this)}
                          excludeFields={Object.keys(schema.fields).filter(
                            (key) =>
                              ![
                                "payrollTypes",
                                "employmentTypes",
                                "payItems",
                                "deductionTypes",
                                "accTitleRelation",
                              ].includes(key)
                          )}
                        />
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(OtherDeductionFormPage);
